import React from "react";
import { Box, Flex, Text } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";
import Heading from "../common/Heading";
import { GetDogProfileQueryResult } from "../../generated/graphql";

interface Props {
  dog: GetDogProfileQueryResult["data"]["dog"];
}

const Stats = ({ dog }: Props) => {
  const { t } = useTranslation("dogprofile");
  return (
    <Flex
      sx={{
        flexDirection: "column",
        mt: 1
      }}
    >
      <Flex
        sx={{
          flexWrap: "wrap"
        }}
      >
        {dog.stats.map(stat => {
          return (
            !!stat.bookingsCount && (
              <Box
                width={[1 / 2, 1 / 2, 1 / 3]}
                key={stat.serviceType.id}
                px={[2, 2, 0]}
                mt={3}
              >
                <Heading as="h4" variant="highlight">
                  {t("serviceTypeBookings", {
                    service: t(`common:serviceType${stat.serviceType.id}`)
                  })}
                </Heading>
                <Text
                  sx={{
                    color: "inuOrange",
                    fontSize: "32px",
                    fontWeight: "300",
                    lineHeight: "32px",
                    textShadow: "0 0 25px 0 rgba(38,55,70,0.1)"
                  }}
                >
                  {stat.bookingsCount}
                </Text>
              </Box>
            )
          );
        })}
      </Flex>
    </Flex>
  );
};

export default Stats;
